import { Injectable } from '@angular/core';
import { Database, ref, set } from '@angular/fire/database';
import { UserService } from './user.service';
import * as moment from 'moment';

interface CreatePDReportCommand {
  userId: string;
  startDate: string;
  traceId: string;
}

@Injectable({ providedIn: 'root' })
export class PdfReportService {
  sendingMail = false;
  tokenGenerated = false;
  commandPath = "/v0/data/queue";

  constructor(private db: Database, private userService: UserService) {}

  private newTraceId(): string {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  observeToken(_traceId: string): void {}

  async triggerExportDataPdfReport(): Promise<void> {
    let startDate =   moment().format('YYYY-MM-DD');
    const command: CreatePDReportCommand = {
      userId: this.userService.user.id,
      startDate,
      traceId: this.newTraceId(),
    };
    const query = ref(this.db, `${this.commandPath}/${command.traceId}`);
    this.observeToken(command.traceId);
    await set(query, command);
    this.sendingMail = false;
    this.tokenGenerated = true;
  }
}




